export default __webpack_public_path__ + "static/media/car-troubles.eb0e96b3.webp";